import { __assign } from "tslib";
import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import CloseButton from '../../../Button/CloseButton';
import s from './LiveNotificationCard.scss';
var LiveNotificationCard = function (_a) {
    var children = _a.children, onClose = _a.onClose, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, biData = _a.biData;
    return (React.createElement("div", { className: s['root'], onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement("div", { className: s['content'] }, children),
        React.createElement(CloseButton, { className: s['close-btn'], onClick: onClose, biData: BiData(__assign({ evid: 655 }, biData)) })));
};
LiveNotificationCard.displayName = 'LiveNotificationCard';
export default LiveNotificationCard;
//# sourceMappingURL=LiveNotificationCard.js.map